import { AppBundle } from 'api/optimalprint-sdk.d';
import { PricesToFetch } from 'store/price/types';

const collectPricesFromProduct = (
  products: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem[],
  categoryId: number,
  encryptedDesignId?: string,
) => {
  const productIds: number[] = [];

  products.forEach((product) => {
    if (productIds.indexOf(product.productId) < 0) {
      productIds.push(product.productId);
    }
    if (product.bundleGroups) {
      product.bundleGroups.forEach((bg) => {
        bg.items?.forEach((bundledItem) => {
          if (productIds.indexOf(bundledItem.productId) < 0) {
            productIds.push(bundledItem.productId);
          }
        });
      });
    }
  });

  const result: PricesToFetch = {
    [categoryId]: {
      categoryId,
      productIds,
      encryptedDesignId,
    },
  };
  return result;
};

export default collectPricesFromProduct;
